export default __webpack_public_path__ + "media/images/icons/icon-play-d5dd6aae98c6049b74bd5e4f9b02a85d.svg";